export default {"src":"/_next/static/media/Elephant_small.416d6fc2.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};